import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { MatButtonModule, MatButtonToggleModule, MatIconModule } from '@angular/material';
import { GridsterModule } from 'angular-gridster2';
import { DynamicModule } from 'ng-dynamic-component';
import { DashboardComponent } from './dashboard.component';
import { dashboardRoutes } from './dashboard.routes';
import { LayoutModule } from '../shared/layout/layout.module';
import { SharedModule } from '../shared/shared.module';
import { PercentComponent } from './percent/percent.component';
import { CallQueueComponent } from './call-queue/call-queue.component';
import { UsersComponent } from './users/users.component';
import { DashboardService } from './dashboard.service';
import { NoDataComponent } from './no-data/no-data.component';
import { DontAcceptIncomingCallsComponent } from './dont-accept-incoming-calls/dont-accept-incoming-calls.component';
import { UsersService } from './users/users.service';
import { NgxPermissionsModule } from 'ngx-permissions';
import { InboundCallsComponent } from './inbound-calls/inbound-calls.component';
import { OutboundCallsComponent } from './outbound-calls/outbound-calls.component';

const components = [
  DashboardComponent,
  InboundCallsComponent,
  OutboundCallsComponent,
  PercentComponent,
  CallQueueComponent,
  UsersComponent,
  NoDataComponent,
  DontAcceptIncomingCallsComponent
];

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(dashboardRoutes),
    LayoutModule,
    GridsterModule,
    MatIconModule,
    SharedModule,
    MatButtonModule,
    DynamicModule.withComponents(components),
    MatButtonToggleModule,
    TranslateModule,
    NgxPermissionsModule
  ],
  declarations: components,
  exports: components,
  entryComponents: components,
  providers: [DashboardService, UsersService]
})
export class DashboardModule {}
